export default __webpack_public_path__ + "static/AGaramondPro-Regular-eabaaf6af638885841d75d3fc747d8ab.ttf";